export default __webpack_public_path__ + "static/media/icon-building.e7b53cd3.svg";